import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from '@libs/landings/starfin/components/home/home.component';
import { AccessionComponent } from '@libs/landings/starfin/components/home/components/accession/accession.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PlateComponent } from '@libs/landings/starfin/components/home/components/plate/plate.component';
import { ReasonComponent } from '@libs/landings/starfin/components/home/components/reason/reason.component';
import { LoanConditionsComponent } from '@libs/landings/starfin/components/home/components/loan-conditions/loan-conditions.component';
import { ServiceManualComponent } from '@libs/landings/starfin/components/home/components/service-manual/service-manual.component';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    TranslateModule,
    HomeRoutingModule,
    MatProgressSpinnerModule,
    AccessionComponent,
    PlateComponent,
    ReasonComponent,
    LoanConditionsComponent,
    ServiceManualComponent,
  ],
})
export class HomeModule {}
